var yuchang = [
    [119.533113, 39.862011, '浅水湾浴场'],
    [119.350861, 39.713569, '黄金海岸风景区'],
    [119.533178, 39.842592, '鸽子窝公园'],
    [119.495740, 39.819591, '老虎石海上公园'],
    [119.431343, 39.792554, '南戴河海滨浴场'],
    [119.436062, 39.797540, '天马浴场'],
    [119.438420, 39.799600, '蓝色海岸休闲海滩'],
    [119.439758, 39.800401, '仙螺岛'],
    [119.350392, 39.712393, '黄金海岸浴场'],
    [119.329173, 39.660733, '阿那亚'],
    [119.804208, 39.974207, '老龙头'],
    [119.756782, 39.960973, '乐岛'],
    [119.633280, 39.922863, '东山浴场'],
    [119.542007, 39.890620, '金屋浴场'],
    [119.557470, 39.904438, '西浴场'],
]

var jingdian = [
    [119.521253, 39.892867, '秦皇岛博物馆'],
    [119.610721, 39.929900, '秦皇岛市玻璃博物馆'],
    [119.764217, 39.961759, '乐岛海洋王国'],
    [119.295892, 39.606214, '渔岛'],
    [119.219838, 39.575355, '渔田七里海'],
    [119.570149, 39.911993, '新澳海底世界'],
    [119.331554, 39.675171, '圣蓝海洋公园'],
    [119.542041, 39.826621, '碧螺塔酒吧公园'],
    [119.361250, 39.741552, '南戴河国际娱乐中心'],
    [119.258466, 39.870819, '紫金湾游乐场'],
    [119.766431, 40.017202, '天下第一关'],
    [119.371755, 40.110826, '冰塘峪长城风情大峡谷'],
    [118.830153, 40.211735, '御水湾温泉水上乐园'],
    [119.314870, 39.642311, '昌黎国际滑沙中心'],
    [119.629944, 39.919654, '公主号游船'],
    [119.542143, 39.833215, '浪淘沙号游船'],
    [119.805985, 39.973187, '求仙6号游船'],
    [119.473407, 39.913924, '秦宇宙智慧乐园'],
    [119.578168, 40.138878, '傍水崖景区'],
    [119.520372, 39.831436, '秦皇宫'],
    [119.368182, 40.137450, '花果山'],
    [119.829416, 40.042677, '孟姜女庙'],
    [119.527788, 39.876619, '野生动物园'],
    [119.758615, 40.123781, '九门口水上长城'],
    [119.572246, 39.915297, '星际小蚂蚁乐园'],
    [119.561080, 39.912894, '秦皇之眼摩天轮'],
    [119.504837, 39.833405, '怪楼奇园'],
    [119.502306, 39.831934, '不同艺术小镇'],
    [118.740091, 40.200063, '迁安白羊峪'],
    [118.623740, 40.029875, '亚滦湾桃源里景区'],
    [119.258466, 39.870819, '紫金湾游乐场'],
    [119.356641, 40.073011, '龙云谷景区'],
]

var restaurant = [
    [119.764049, 40.012771, '四条包子'],
    [119.605401, 39.971164, '四条包子'],
    [119.545027, 39.930175, '四条包子'],
    [119.763799, 40.015579, '回记绿豆糕'],
    [119.169651, 39.717281, '昌黎赵家馆饺子'],
    [119.761980, 40.007038, '叶存利'],
    [119.424254, 39.799136, '叶存利'],
    [119.580061, 39.934037, '叶存利'],
    [119.522630, 39.914433, '叶存利'],
    [119.497056, 39.826809, '叶存利'],
    [119.551146, 39.910465, '叶存利'],
    [119.600699, 39.945146, '叶存利'],
    [119.537502, 39.928019, '叶存利'],
    [119.495628, 39.828860, '叶存利'],
    [119.434165, 39.797172, '叶存利'],
    [119.587501, 39.952439, '叶存利'],
    [119.529743, 39.841131, '叶存利'],
    [119.500217, 39.830047, '叶存利'],
    [119.752668, 40.003292, '常品轩荤锅'],
    [119.758029, 40.006416, '伊品轩荤锅'],
    [119.755233, 40.007311, '清碳居荤锅'],
    [119.575740, 39.958963, '赵家馆'],
    [119.169651, 39.717281, '赵家馆'],
    [119.203013, 39.712859, '赵家馆'],
    [119.422949, 39.803404, '赵家馆'],
    [119.787047, 39.982928, '赵家馆'],
    [119.310822, 39.653403, '赵家馆'],
    [119.603458, 39.936131, '杨肠子'],
    [119.264392, 39.875931, '杨肠子'],
    [119.492789, 39.830525, '杨肠子'],
    [119.490748, 39.828918, '天沅酒家'],
    [119.497883, 39.837491, '陆瑶·海味小馆'],
    [119.506809, 39.838380, '同德烤鸭店'],
    [119.504997, 39.839194, '深海渔港海鲜酒楼'],
    [119.494057, 39.840121, '尚座家常菜'],
    [119.501089, 39.841460, '富中小厨海鲜家常菜'],
]

var hotail = [
    [119.307249, 39.630916, '英迪格酒店'],
    [119.562786, 39.909089, '秦皇岛香格里拉大酒店'],
    [119.517174, 39.833495, '喜来登酒店'],
    [119.411851, 39.779428, '秦皇岛万豪度假酒店'],
    [119.411851, 39.779428, '秦皇岛万豪度假酒店'],
    [119.590506, 39.934374, '秦皇岛海港万豪万枫酒店'],
    [119.530022, 39.823233, '黄金海岸度假村'],
    [119.598845, 39.959112, '秦皇岛君御大酒店'],
    [119.493908, 39.823513, '幸运国际酒店'],
    [119.651204, 39.950294, '秦皇岛晨砻酒店'],
    [119.572469, 39.914624, '秦皇国际大酒店'],
    [119.448942, 39.905799, '万怡酒店'],
]

var nianka = [
    '野生动物园',
    '新澳海底世界',
    '碧螺塔酒吧公园',
    '天下第一关',
    '秦皇之眼摩天轮',
    '怪楼奇园',
    '不同艺术小镇',
    '迁安白羊峪',
    '亚滦湾桃源里景区',
    '南戴河国际娱乐中心',
    '九门口水上长城',
    '老龙头',
    '星际小蚂蚁乐园',
    '圣蓝海洋公园',
    '御水湾温泉水上乐园',
    '昌黎国际滑沙中心',
    '冰塘峪长城风情大峡谷',
    '秦宇宙智慧乐园',
    '龙云谷景区',
    '公主号游船',
    '傍水崖景区',
    '求仙6号游船',
    '浪淘沙号游船',
    '秦皇宫',
    '鸽子窝公园',
    '花果山',
    '孟姜女庙',
]

var qinhuangdao = [
    {
        name: '浴场',
        group: 'base',
        list: yuchang,
        show: true,
        color: 'blue'
    },
    {
        name: '景点',
        group: 'base',
        list: jingdian,
        show: true,
        color: 'red'
    },
    {
        name: '餐馆',
        group: 'base',
        list: restaurant,
        show: false,
        color: 'green'
    },
    {
        name: '酒店',
        group: 'base',
        list: hotail,
        show: false,
        color: 'green'
    },
    {
        name: '年卡',
        group: 'level1',
        list: nianka,
        show: false,
        color: 'plum'
    }
]


export default qinhuangdao